<ng-container *transloco="let t">
  <div class="hero h-full">
    <div class="hero-content w-full text-center">
      <div class="max-w-md">
        <h1 class="text-5xl font-bold">Hello there</h1>
        <p class="py-6">
          Provident cupiditate voluptatem et in. Quaerat fugiat ut assumenda
          excepturi exercitationem quasi. In deleniti eaque aut repudiandae et a
          id nisi.
        </p>
        <button class="btn btn-primary" (click)="getStarted()">
          {{ t('dashboard-get-started-button') }}
        </button>
      </div>
    </div>
  </div>
</ng-container>
